export default __webpack_public_path__ + "static/media/self_pickup.af33600d.svg";